import React from 'react';

const TitleSummary = () => {
    return (
      <React.Fragment>
          <h1 className="display-4">Everton Souza</h1>
          <p className="lead">
            Full Stack Developer, Leitor Assíduo de Livros Diversos.
          </p>
      </React.Fragment>
    )
}
export default TitleSummary;